var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash",
    d: "M1,.5V-10H13V.5a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,11.5,2h-9a1.447,1.447,0,0,1-1.062-.437A1.447,1.447,0,0,1,1,.5Zm8.5-8v7a.487.487,0,0,0,.141.359A.487.487,0,0,0,10,0a.487.487,0,0,0,.359-.141A.487.487,0,0,0,10.5-.5v-7a.487.487,0,0,0-.141-.359A.487.487,0,0,0,10-8a.487.487,0,0,0-.359.141A.487.487,0,0,0,9.5-7.5Zm-3,0v7a.487.487,0,0,0,.141.359A.487.487,0,0,0,7,0a.487.487,0,0,0,.359-.141A.487.487,0,0,0,7.5-.5v-7a.487.487,0,0,0-.141-.359A.487.487,0,0,0,7-8a.487.487,0,0,0-.359.141A.487.487,0,0,0,6.5-7.5Zm-3,0v7a.487.487,0,0,0,.141.359A.487.487,0,0,0,4,0a.487.487,0,0,0,.359-.141A.487.487,0,0,0,4.5-.5v-7a.487.487,0,0,0-.141-.359A.487.487,0,0,0,4-8a.487.487,0,0,0-.359.141A.487.487,0,0,0,3.5-7.5Zm10-5.5a.487.487,0,0,1,.359.141A.487.487,0,0,1,14-12.5v1a.487.487,0,0,1-.141.359A.487.487,0,0,1,13.5-11H.5a.487.487,0,0,1-.359-.141A.487.487,0,0,1,0-11.5v-1a.487.487,0,0,1,.141-.359A.487.487,0,0,1,.5-13H4.25l.281-.594A.728.728,0,0,1,5.219-14H8.781a.728.728,0,0,1,.688.406L9.75-13Z",
    transform: "translate(0 14)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.32703ea91893c0e263913a29115dfd2b.svg";
export { ForwardRef as ReactComponent };